import {
  i18n,
} from '@i18n';
import axios from 'axios';
import {
  z,
} from 'zod';

import zodLocale from '@/constants/zod/export.ts';
import {
  TSupportedLocale,
} from '@/types/i18n.ts';
import {
  primeVueStore,
} from '@/utils/primevue.ts';

/**
 * Sets the language for the application, including updating the i18n locale, Zod error messages, HTML lang attribute, and Axios Accept-Language header.
 * It also updates translations for job, management tabs, and clears the PT98 translations cache.
 * @param language
 */
export function setLanguage(language: TSupportedLocale): void {
  i18n.global.locale.value = language;

  z.setErrorMap(zodLocale[language]);

  document.querySelector('html')?.setAttribute('lang', language);
  axios.defaults.headers.common['Accept-Language'] = language;

  // Update Locale Store
  primeVueStore.setLocale(language);
}
